import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getDelegations(data) {

		let url = config.api.baseUrl + '/api/delegations' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	createDelegation(data) {

		let url = config.api.baseUrl + '/api/delegations'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	updateDelegation(data) {

		let url = config.api.baseUrl + '/api/delegations'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	deleteDelegation(data) {

		let url = config.api.baseUrl + '/api/delegations' + data

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/delegations.js